import { TableColumn } from "react-data-table-component";
import { CallSchedule } from "../../../../types/api";
import { transformDate } from "../../../../utils/date-utils";
import { Button } from "@mui/material";

export const CALL_SCHEDULE_TABLE_COLUMNS: TableColumn<CallSchedule>[] = [
  {
    name: "ID",
    selector: (row) => row.id ?? "",
    sortable: true,
  },
  {
    name: "Schedule Description",
    cell: (row) => row.scheduleDescription,
    wrap: true,
  },
  {
    name: "CRON Expression",
    selector: (row) => row.cronExpression ?? "",
  },
  {
    name: "Date Created",
    selector: (row) => row.createdOn?.toString() ?? "",
    cell: (row) => transformDate(row.createdOn?.toString()),
    sortable: true,
  },
];

export const DELETED_CALL_SCHEDULE_TABLE_COLUMNS: (
  onRestoreClick: React.MouseEventHandler<HTMLButtonElement>
) => TableColumn<CallSchedule>[] = (onRestoreClick: React.MouseEventHandler<HTMLButtonElement>) => [
  ...CALL_SCHEDULE_TABLE_COLUMNS,
  {
    name: "Actions",
    cell: (row) => (
      <Button id={`${row.id}`} onClick={onRestoreClick}>
        Restore
      </Button>
    ),
    button: true,
  },
];
